<template>
    <div>
        <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Dvorana: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <dvorana-forma
                        :disabled="true"
                        :id="id"
                        :modal="false"
                        :action="'show'"
                        @returnData="setData"
                >
                </dvorana-forma>
            </div>
        </div>
    </div>
</template>

<script>
import DvoranaForma from "@/views/pages/Skupovi/Dvorane/DvoranaForma";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
export default {
    name: "DvoranaDetails",
    components:{
        DvoranaForma,
        SkupoviNavigation
    },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.dvorana_id,
            skup_id: this.$route.params.skup_id,
            naziv: ''
        }
    },
    methods:{
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/dvorane',
                    name: 'Dvorane'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/dvorane/' + this.id,
                    name: 'Dvorana: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv
            this.setBreadcrumbs()
        },

    },
    mounted() {
    }
}
</script>

<style scoped>

</style>